import React, { Component } from "react";
import { Icon } from "@blueprintjs/core";
import { connect } from "react-redux";
import { fetchConversationMembers } from "../../../store/messaging/operations";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { navigate } from "../../../store/navigation/operations";
import { FullUser } from "../User";
export class ConversationMemberSelector extends Component {
  componentDidMount() {
    this.props.fetchConversationMembers();
  }
  
  render() {
    return (
      <div className="new-message-selector-popover">
        {this.props.loading && <LoadingIndicator />}
        {this.props.conversationMembers.map(memberGuid => (
          <div className="item" key={memberGuid} onClick={_ => this.props.navigate(`/messages/new/${memberGuid}`)}>
            <FullUser userGuid={memberGuid} />
            <Icon icon="chevron-right" iconSize="16" className="icon more-indicator" />
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    conversationMembers: state.messaging.conversation_members,
    loading: state.messaging.loading_conversation_members,
    locale: state.i18n.locale
  };
};

const mapDispatchToProps = dispatch => ({
  fetchConversationMembers: _ => dispatch(fetchConversationMembers()),
  navigate: to => dispatch(navigate(to))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationMemberSelector);
